'use strict';

/*global app*/
/*global services*/
/*global isEmpty*/
/*global blockElement*/
/*global unBlockElement*/
/*global invokeCallback*/
/*global wrrSuccess*/
/*global wrrNotFound*/

function PickingService() {
  this.$container = $('body');

  this.isLoading = false;

  this.init();
}

PickingService.prototype = $.extend({}, {
  constructor: 'PickingService',

  registerCallbacks: function registerCallbacks() {
    var _this = this;

    $('body').on('click', '.open-picking-process', function () {
      _this.openPickingProcess($(this).data('multipick'));

      return false;
    });

    return _this;
  },

  //----------------------------------------------------------------------------

  getPicking: function getPicking(step, isMultipick, negativePriority, callback) {
    var _this = this;

    var data = {
      Step: step,
      IsMultipick: isMultipick,
      NegativePriority: negativePriority,
      AreaId: app.param('active_area_id')
    };

    blockElement(_this.$container);
    $.get(app.formation('picking:get'), data, function (res) {
      unBlockElement(_this.$container);

      if (res.msg === 'SUCCESS') {
        if (res.data.Result === wrrSuccess) {
          location.href = app.path('picking_process', { WebDocumentRID: res.data.WebDocumentRID });
        } else if (res.data.Result === wrrNotFound && callback) {
          invokeCallback(callback);
        } else {
          app.viewErrorMessage(res.data.Message);
        }
      } else {
        app.viewErrorMessage(res.error);
      }

      if (!(res.msg === 'SUCCESS' && res.data.Result === wrrSuccess)) {
        _this.isLoading = false;
      }
    });

    return _this;
  },

  doOpenPickingProcess: function doOpenPickingProcess(isMultipick) {
    var _this = this;

    _this.isLoading = true;
    if (isMultipick) {
      //v pripade multipicku musim na dvakrat
      _this.getPicking(1, isMultipick, false, function () {
        services.get('confirm-service').confirm({
          title: app.t('picking.multipick'),
          content: app.t('picking.negative_priority')
        }, function (negativePriority) {
          _this.getPicking(2, isMultipick, negativePriority);
        });
      });
    } else {
      _this.getPicking(1, false, false);
    }

    return _this;
  },

  openPickingProcess: function openPickingProcess(isMultipick) {
    var _this = this;

    if (_this.isLoading) {
      return _this;
    }

    if (isEmpty(app.param('printer_group'))) {
      services.get('printer-setting').openPrinterSetting(function () {
        _this.doOpenPickingProcess(isMultipick);
      });

      return _this;
    }

    _this.doOpenPickingProcess(isMultipick);

    return _this;
  },

  getDocumentsInfo: function getDocumentsInfo(webDocumentRID, callback) {
    var _this = this;

    blockElement(_this.$container);
    $.get(app.path('picking_get_documents_info', { WebDocumentRID: webDocumentRID }), function (res) {
      unBlockElement(_this.$container);
      if (res.msg === 'SUCCESS') {
        invokeCallback(callback, res.data);
      } else {
        app.viewErrorMessage(res.error);
      }
    });

    return _this;
  },

  //----------------------------------------------------------------------------

  init: function init() {
    var _this = this;

    _this.registerCallbacks();

    return _this;
  }
});

